<template>
  <div>
    <div
      v-for="i in 50"
      :key="`snow-${i}`"
      class="snow"/>
  </div>
</template>
<script>
/**
 * Просто снег
 * С 15.12 по 15.01
 */
export default {
  name: 'snow',
}
</script>
<style lang="scss">
@use 'sass:math';

@function random_range($min, $max) {
  @return $min + math.floor(math.random() * (($max - $min) + 1));
}

@mixin snowflake($i) {
  $random-x: random_range(3000, 97000) * 0.001vw;
  $random-offset: random_range(-100000, 100000) * 0.0001vw;
  $random-x-end: $random-x + $random-offset;
  $random-x-end-yoyo: $random-x + math.div($random-offset, 2);
  $random-yoyo-time: math.div(random_range(30000, 80000), 100000);
  $random-yoyo-y: ($random-yoyo-time * 93vh) + 3vh;
  $random-scale: math.random(10000) * 0.0001;
  $fall-duration: random_range(10, 30) * 1s;
  $fall-delay: math.random(30) * -1s;

  opacity: math.random(10000) * 0.0001;
  transform: translate($random-x, -10px) scale($random-scale);
  animation: fall-#{$i} $fall-duration $fall-delay linear infinite;

  @keyframes fall-#{$i} {
    #{math.percentage($random-yoyo-time)} {
      transform: translate($random-x-end, $random-yoyo-y) scale($random-scale);
    }

    to {
      transform: translate($random-x-end-yoyo, 99vh) scale($random-scale);
    }
  }
}

$total: 50;

.snow {
  position: absolute;
  width: 10px;
  height: 10px;
  background: var(--white-color);
  border-radius: 50%;
  z-index: 10;

  @for $i from 1 through $total {
    &:nth-child(#{$i}) {
      @include snowflake($i);
    }
  }
}
</style>
